/**
 * La lista blanca del ALMACÉN QUE ES SÓLO ALMACÉN (marca blanca).
 *
 * 🚨 POR QUÉ EXISTE (founder, 23-oct-2026, entrando a la cuenta de Almacén 1): «sí puedo ver precios y todas las
 *    demás funciones. ¿Has revisado bien?». No: #2088 sólo tapó los montos en la lista de encargos, y la lista blanca
 *    del rol `almacen` (`RUTAS_DEL_ROL_ALMACEN`) está pensada para un proveedor EXTERNO que además despacha (North
 *    Express, Suplemax): abre el Catálogo con los precios mayoristas, Productos, Clientes, Billetera, Ingresos…
 *
 * ⭐ ALMACÉN 1 FABRICA Y DESPACHA, NADA MÁS. Le vende el Shilajit a Suplemax a 15 y Suplemax lo publica a 25: no
 *    debe ver el catálogo ni los precios de venta. Lo que el founder pidió, con sus palabras: «solo debe verse la
 *    página de despachos, inicio y lo básico… su liquidación, donde ven la cantidad de productos, su pago pendiente».
 *
 * 🪤 ES UNA LISTA APARTE Y MÁS CORTA, no una excepción dentro de la otra: el almacén-proveedor sigue con la suya.
 *    Quién es «sólo almacén» lo decide un hecho (plan `almacen` y no está en `drop_proveedores`), ver
 *    `useSoloAlmacen`. Esta lista cuida la RUTA (`elPortonDelPlan`) y el MENÚ (`Sidebar`), las dos con la misma
 *    función, como las otras listas de rol.
 */
import { ROUTES } from '@/config/routes.config';
import { rutaSinTienda } from './rutasDelRolDrop';
import { matchPath } from 'react-router-dom';

export const RUTAS_DEL_SOLO_ALMACEN: readonly string[] = [
  ROUTES.HOME,
  ROUTES.NOTIFICACIONES,
  // 🪤 SIN VENTAS (founder, 23-oct, en reunión con Almacén 1: «se ha ido a Ventas y como que se perdía»): su trabajo
  //    está en las guías. Queda la Entrega de cada pedido (y el detalle, que manda ahí), que es a donde llevan las guías.
  ROUTES.OPS_ORDER_DETAIL, ROUTES.OPS_ORDER_ENTREGA,
  // Despachos: entregas, guías de despacho, por recoger.
  ROUTES.ENTREGAS, ROUTES.OPS_LOGISTICA, ROUTES.ENTREGAS_GUIAS, ROUTES.ENTREGAS_POR_RECOGER,
  // Sus liquidaciones día por día (26-oct-2026): el almacén que también es courier (North Express) rinde lo que cobra.
  // Quien no es courier no la ve: la barra la filtra por papel.
  ROUTES.ENTREGAS_LIQUIDACIONES,
  // Lo que tiene en stock y lo que se le debe.
  ROUTES.DROPSHIPPING_SMARTYDROP_INVENTARIO, ROUTES.PRODUCTS_INVENTORY, ROUTES.PRODUCTS_INVENTORY_PRODUCT,
  ROUTES.DROPSHIPPING_SMARTYDROP_LIQUIDACION,
  // Con quién despacha y en qué papel imprime.
  ROUTES.TRANSPORT_AGENCIES, ROUTES.TRANSPORT_AGENCY_COURIER_DETAIL, ROUTES.TRANSPORT_ROTULOS,
  // Lo básico de Ajustes: su negocio, su gente, sus couriers.
  ROUTES.SETTINGS, ROUTES.SETTINGS_GENERAL, ROUTES.SETTINGS_BUSINESS,
  ROUTES.SETTINGS_USERS, ROUTES.SETTINGS_USERS_ROLES, ROUTES.SETTINGS_USERS_SECURITY,
  ROUTES.SETTINGS_LOCATIONS,
  ROUTES.SETTINGS_INTEGRATIONS, ROUTES.SETTINGS_INTEGRATIONS_SHALOM, ROUTES.SETTINGS_INTEGRATIONS_OLVA,
  ROUTES.SETTINGS_SHALOM_AGENCIES,
];

/** A dónde vuelve si abre algo que no es suyo: a su Inicio. */
export const A_DONDE_VA_EL_SOLO_ALMACEN = ROUTES.HOME;

export function laRutaEsDelSoloAlmacen(pathname: string): boolean {
  const ruta = rutaSinTienda(pathname);
  return RUTAS_DEL_SOLO_ALMACEN.some((patron) => matchPath({ path: patron, end: true }, ruta) !== null);
}
